import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IWholesaleOrder,
  IWholesaleOrderPayload,
  IWholesaleOrderRequest,
  IWholesaleOrderResponse,
} from "./wholesale.interface";
import {
  getWholesaleOrderByIDService,
  getWholesaleOrdersService,
  addWholesaleOrderService,
  updateWholesaleOrderService,
} from "./wholesale.service";

export const getWholesaleOrders = createAsyncThunk<
  IWholesaleOrderResponse,
  IWholesaleOrderRequest,
  { rejectValue: any }
>("wholesale/getWholesaleOrders", async (payload, { rejectWithValue }) => {
  try {
    const { page, limit, sort, order, search } = payload ?? {};

    const data = await getWholesaleOrdersService(
      page ?? 0,
      limit ?? 10,
      sort ?? "inserted",
      order ?? "desc",
      search ?? ""
    );

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const getWholesaleOrderByID = createAsyncThunk<
  IWholesaleOrder,
  string,
  { rejectValue: any }
>("wholesale/getWholesaleOrderByID", async (id, { rejectWithValue }) => {
  try {
    const data = await getWholesaleOrderByIDService(id);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const addWholesaleOrder = createAsyncThunk<
  IWholesaleOrder,
  IWholesaleOrderPayload,
  { rejectValue: any }
>("wholesale/addWholesaleOrder", async (payload, { rejectWithValue }) => {
  try {
    const data = await addWholesaleOrderService(payload);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const updateWholesaleOrder = createAsyncThunk<
  IWholesaleOrder,
  { id: string; payload: IWholesaleOrderPayload },
  { rejectValue: any }
>(
  "wholesale/updateWholesaleOrder",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const data = await updateWholesaleOrderService(id, payload);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data?.message);
    }
  }
);
